
export const DOM = {
	
	id: (s) => document.getElementById(s),
	qs: (s) => document.querySelector(s), 
	qsa: (s) => document.querySelectorAll(s), 
	
};